const MIN_VERTICES = 3

export function openRing(pts) {
  if (!Array.isArray(pts) || pts.length === 0) return []
  if (pts.length >= 2 && samePoint(pts[0], pts[pts.length - 1])) return pts.slice(0, -1)
  return pts.slice()
}

export function closeRing(pts) {
  const open = openRing(pts)
  if (!open.length) return open
  return open.concat([open[0]])
}

export function removeVertexAt(open, index) {
  if (!Array.isArray(open) || open.length <= MIN_VERTICES) return open.slice()
  if (index < 0 || index >= open.length) return open.slice()
  return open.filter((_, i) => i !== index)
}

export function insertVertexAt(open, index, uv) {
  const next = open.slice()
  const at = Math.max(0, Math.min(index, next.length))
  next.splice(at, 0, uv)
  return next
}

export function minVertices() {
  return MIN_VERTICES
}

const DELETE_KEYS = new Set(["Delete", "Backspace"])

export function isDeleteKey(key) {
  return DELETE_KEYS.has(key)
}

function samePoint(a, b) {
  return a[0] === b[0] && a[1] === b[1]
}
